
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Card from "../components/Card.vue";
import LargeCard from "../components/LargeCard.vue";
import CardData from "../models/CardData";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import { ICardData } from "../@types/interface.d";

interface DataType {
  cards: CardData[];
  selectCount: number;
  maximizeCard?: CardData;
}

interface MethodType {
  init: () => void;
  onSelect: () => void;
  clearMaximize: () => void;
}

interface ComputedType {
  pairCount: number;
  maximizedUrl: string;
}

export default Vue.extend({
  name: "cards",
  components: {
    Card,
    LargeCard,
    Headline,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): DataType {
    return {
      cards: [],
      selectCount: 0,
      maximizeCard: undefined,
    };
  },
  created() {
    this.init();
  },
  computed: {
    pairCount() {
      return (this as any).cards.filter((v: CardData) => v.opened).length / 2;
    },
    maximizedUrl() {
      return (this as any).maximizeCard ? (this as any).maximizeCard.imageUrl : "";
    },
  },
  methods: {
    init() {
      fetch("/api/memory_cards").then(res => res.json()).then((data: ICardData[]) => {
        this.cards = data.map((v: ICardData) => new CardData(v));
      });
      this.selectCount = 0;
      this.maximizeCard = undefined;
    },
    onSelect(id: number, dblClick: boolean) {
      if (this.maximizeCard) {
        this.maximizeCard = undefined;
        return;
      }
      const card = this.cards.find(v => v.id === id);
      if (!card) {
        return;
      }
      if (dblClick && card.opened) {
        this.maximizeCard = card;
        return;
      }
      if (card.selected || card.opened) {
        return;
      }
      const selected = this.cards.filter(v => v.selected && !v.opened);
      if (selected.length >= 2) {
        return;
      }
      card.selected = true;
      if (selected.length === 1) {
        if (selected[0].tagId === card.tagId) {
          selected[0].opened = true;
          card.opened = true;
        } else {
          setTimeout(() => {
            this.cards.forEach((v: CardData) => {
              v.selected = false;
            });
          }, 1200);
        }
        this.selectCount++;
      }
    },
    clearMaximize() {
      this.maximizeCard = undefined;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
